import { MessageContext } from './MessageContext';
export function MessageProvider(props) {
    const { children, onFootnoteClick } = props;
    return <MessageContext.Provider value={{ onFootnoteClick }}>{children}</MessageContext.Provider>;
}
